//	Ref: https://www.codementor.io/yurio/all-you-need-is-react-firebase-4v7g9p4kf
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import 'firebase/auth'
import settings from '../../config/settings'


const firebaseConfig = settings.firebase.config
firebase.initializeApp(firebaseConfig)

const auth = firebase.auth()

const firestoreSettings = settings.firestore
const firestore = firebase.firestore()
firestore.settings(firestoreSettings)

const functions = firebase.functions()

const storage = firebase.storage()

const userImagesRef = 'useruploadedimages'


export {
	firebase, // only use this for the namespace
	auth,
	firestore,
	functions,
	storage,
	userImagesRef
}



// WEBPACK FOOTER //
// ./src/utilities/firebase.js